import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { PlugIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { InputLabel, makeStyles } from "@material-ui/core";

const useOwnStyles = makeStyles({
    container: {
        paddingTop: 21,
        paddingLeft: 21,
        paddingRight: 24,
        paddingBottom: 21,

        marginTop: 40,

        borderColor: Colors.anthracite25,
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: 8,

        display: "flex",
        flexDirection: "column",
    },
});

export const ChargerAdditionalElectricDemandForm: FC = () => {
    const classes = useStyles();
    const ownClasses = useOwnStyles();
    const { values, getFieldProps, setValues } = useFormModel<
        ChangeNames.CHARGER_ADDITIONAL_ELECTRIC_DEMAND
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                classes={{
                    container: ownClasses.container,
                }}
                icon={<PlugIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Leistungsbedarf zusätzlich zur Ladeeinrichtung
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Sofern zusätzliche Verbraucher am Netzanschluss geplant sind, erfassen
                            Sie diese bitte hier als Gesamtleistung.
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.chargerAdditionalElectricDemand.value.installed}
                        {...getFieldProps("chargerAdditionalElectricDemand.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.chargerAdditionalElectricDemand.value.installed = checked;
                                values.chargerAdditionalElectricDemand.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.chargerAdditionalElectricDemand.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={
                                values.chargerAdditionalElectricDemand.value.demand.precision
                            }
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.chargerAdditionalElectricDemand.value.demand.unit}
                            value={values.chargerAdditionalElectricDemand.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.chargerAdditionalElectricDemand.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.chargerAdditionalElectricDemand.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
